export const calculateSlaPrice = (slaPricePerGb: number, expectedDataSize: number) => {
  if (expectedDataSize < 50) {
    return slaPricePerGb * 50;
  }

  if (expectedDataSize > 300) {
    return slaPricePerGb * 300;
  }

  return slaPricePerGb * expectedDataSize;
};

export const decodeEncodedPrice = (value?: string) => {
  if (!value) {
    return 0;
  }

  const result = value.startsWith('~f') ? value.slice(2) : value;

  return parseFloat(result);
};

export const toPriceFn =
  (currency: string, decodeDecimalFn = decodeEncodedPrice) =>
  (encodedPrice: string, ...additions: number[]) => {
    const base = decodeDecimalFn(encodedPrice);
    let total = base;

    for (const addition of additions) {
      total = total + addition;
    }

    return encodedPrice ? `${total.toFixed(2)} ${currency}` : '?';
  };
